import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import TripDrawerBody from './TripDrawerBody';
import AreaEditDrawer from '../../components/AreaEditDrawer';
import { ViewMode } from '../../hooks/viewMode';
import { selectSelectedTrip } from '../../redux/store/userData/trips';
import {
  closeTripDrawerAndSetQueries,
  selectViewMode,
} from '../../redux/store/ui/common';
import CircleEditDrawer from '../CircleEditDrawer';
import { ViewType } from '../../hooks/useViewType';
import { selectViewType } from '../../redux/store/ui/common/selectors';
import NestedDrawer from '../shared/NestedDrawer';

const TripDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  const selectedTrip = useSelector(selectSelectedTrip);
  const visible = selectedTrip != null;

  const handleOnClose = () => {
    dispatch(closeTripDrawerAndSetQueries());
  };

  return (
    selectedTrip && (
      <DrawerLayout
        isTripDrawer
        visible={visible}
        title={selectedTrip.id}
        body={<TripDrawerBody />}
        nestedDrawers={
          <>
            {(viewMode !== ViewMode.VEHICLE ||
              viewType === ViewType.TIME_TABLE) && (
              <NestedDrawer name="carEdit" />
            )}
            {viewMode !== ViewMode.AREA && <AreaEditDrawer />}
            {viewMode !== ViewMode.CLAIM && <NestedDrawer name="claim" />}
            {viewMode !== ViewMode.CIRCLE && <CircleEditDrawer />}
            {viewMode !== ViewMode.RECEIPTS && <NestedDrawer name="receipt" />}
            {viewMode !== ViewMode.FUEL_TRANSACTIONS && (
              <NestedDrawer name="fuelTransaction" />
            )}
            {viewMode !== ViewMode.USERS && <NestedDrawer name="users" />}
          </>
        }
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default TripDrawer;
